import { v4 as uuid } from 'uuid';
import { RR_BATCH_TYPE } from '../../enum/table/batch-type.enum';
import { RRISettings } from '../base-settings.interface';
import { RRIConfirmDeleteModalSettings } from '../modal/confirm-delete-modal-settings.interface';

export interface RRIBatchOption<T> extends RRISettings<RR_BATCH_TYPE, T> {
  title: string;
}

export interface RRIDeleteBatchOptionSettings<T> {
  modalSettings: RRIConfirmDeleteModalSettings<T>;
  selectedRows: T[];
}

export interface RRIDownloadBatchOptionSettings<T, R> {
  downloadFileName: string;
  selectedRows: T[];
  generateFilePath: (
    filename: string,
    entity?: T & { productId?: uuid },
  ) => string;
  getFiles: (entity: T) => Promise<R | R[]>;
}

export interface RRIUpdateBatchOptionSettings<T> {
  selectedRows: T[];
  update: (newValues: {}, entities: T[]) => void;
}

export interface RRICustomBatchOptionSettings<T> {
  selectedRows: T[];
  icon: string;
  customType: string;
  label: string;
}
